module.exports = __webpack_public_path__ + "static/media/cochos.50a1865b.png";